import DeliverabilityRate from '@admin/tokens/deliverability_rate'
import Panel from '@admin/components/panel'
import React from 'react'

const mapPropsToPanel = (props, context) => ({
  title: 't(Okay Senders)',
  collection: {
    endpoint: '/api/admin/truevail/admin/deliverability/okay',
    table: [
      { label: 't(ID)', key: 'id', collapsing: true, visible: false },
      { label: 't(Name)', key: 'name', primary: true },
      { label: 't(Sent)', key: 'sent_count', collapsing: true, align: 'right' },
      { label: 't(Open)', key: 'open_rate', collapsing: true, width: 100, align: 'right', format: (domain) => (
        <DeliverabilityRate domain={ domain } metric="open_rate" />
      ) },
      { label: 't(Click)', key: 'click_rate', collapsing: true, width: 100, align: 'right', format: (domain) => (
        <DeliverabilityRate domain={ domain } metric="click_rate" />
      ) },
      { label: 't(Bounce)', key: 'bounce_rate', collapsing: true, width: 100, align: 'right', format: (domain) => (
        <DeliverabilityRate domain={ domain } metric="bounce_rate" />
      ) },
      { label: 't(Soft Bounce)', key: 'soft_bounce_rate', collapsing: true, width: 100, align: 'right', format: (domain) => (
        <DeliverabilityRate domain={ domain } metric="soft_bounce_rate" />
      ) },
      { label: 't(Hard Bounce)', key: 'hard_bounce_rate', collapsing: true, width: 100, align: 'right', format: (domain) => (
        <DeliverabilityRate domain={ domain } metric="hard_bounce_rate" />
      ) },
      { label: 't(Complain)', key: 'complain_rate', collapsing: true, width: 100, align: 'right', format: (domain) => (
        <DeliverabilityRate domain={ domain } metric="complain_rate" />
      ) },
      { label: 't(Unsubscribe)', key: 'unsubscribe_rate', collapsing: true, width: 100, align: 'right', format: (domain) => (
        <DeliverabilityRate domain={ domain } metric="unsubscribe_rate" />
      ) }
    ],
    defaultSort: { key: 'name', order: 'asc' },
    empty: {
      svg: 'globe',
      title: 't(No Subdomains)',
      text: 't(There are no subdomains)'
    },
    entity: 'subdomain',
    onClick: (record) => context.router.push(`/admin/truevail/admin/domains/${record.id}`)
  }
})

export default Panel(null, mapPropsToPanel)
